import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import ConfirmationDialog from 'components/ConfirmationDialog';
import ROUTES from 'routes/constants';
import messages from './messages';
import { finishChecklistSessionAction, finishChecklistSessionOnClickAnalytics } from './actions';

export const buildFinishSessionDialogProps = ({
  isSessionFinished,
  isDialogLoading,
  isDialogOpen,
  onCloseDialog,
  onFinishSessionClick,
  goToPhotoSessions,
  newChecklist,
}) => {
  const defaultProps = {
    open: isDialogOpen,
    onCancel: onCloseDialog,
    isDialogLoading,
  };

  const returnConfirmationAction = () => newChecklist ? onCloseDialog() : goToPhotoSessions();

  return isSessionFinished
    ? {
      ...defaultProps,
      confirmationTitle: messages.finishedSessionTitle,
      confirmationDescription: messages.finishedSessionDescription,
      confirmationButtonText: messages.gotIt,
      confirmationAction: returnConfirmationAction,
    } : {
      ...defaultProps,
      confirmationTitle: messages.finishSessionTitle,
      confirmationDescription: messages.finishSessionDescription,
      confirmationButtonText: messages.finish,
      cancelButtonText: messages.review,
      confirmationAction: onFinishSessionClick,
    };
};

export const FinishSessionDialog = ({
  isSessionFinished,
  isDialogLoading,
  isDialogOpen,
  finishChecklistSession,
  onCloseDialog,
  trackFinishSessionOnClick,
  newChecklist,
  goToPhotoSessions,
}) => {
  const onFinishSessionClick = () => {
    finishChecklistSession();
    trackFinishSessionOnClick();
  };

  const confirmationDialogProps = buildFinishSessionDialogProps({
    isSessionFinished,
    isDialogLoading,
    isDialogOpen,
    onCloseDialog,
    onFinishSessionClick,
    goToPhotoSessions,
    newChecklist,
  });

  return <ConfirmationDialog {...confirmationDialogProps} />;
};

FinishSessionDialog.propTypes = {
  isSessionFinished: PropTypes.bool.isRequired,
  isDialogLoading: PropTypes.bool.isRequired,
  finishChecklistSession: PropTypes.func.isRequired,
  isDialogOpen: PropTypes.string.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  trackFinishSessionOnClick: PropTypes.func.isRequired,
  goToPhotoSessions: PropTypes.func.isRequired,
  newChecklist: PropTypes.bool,
};

export const mapDispatchToProps = (dispatch, { photoSessionId, checklist }) => ({
  finishChecklistSession: () => dispatch(finishChecklistSessionAction({ photoSessionId, checklist })),
  trackFinishSessionOnClick: () => dispatch(finishChecklistSessionOnClickAnalytics({ photoSessionId })),
  goToPhotoSessions: () => dispatch(push(ROUTES.NOT_STARTED_PHOTO_SESSIONS)),
});

export default connect(null, mapDispatchToProps)(FinishSessionDialog);
